import React from "react";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/motion";

export const LINKEDIN_URL = "https://www.linkedin.com/company/which-media-llc-fze/";

const LinkedInFollow = () => (
  <section data-testid="linkedin-follow" className="bg-secondary">
    <div className="mx-auto max-w-[1400px] px-5 md:px-8 py-16 md:py-24">
      <FadeUp>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <p className="kicker mb-4">On LinkedIn</p>
            <h2 className="headline text-4xl md:text-6xl uppercase text-ink leading-[1.02]">
              Follow the group<br />
              <span className="text-primary">shaping education intelligence.</span>
            </h2>
            <p className="mt-6 max-w-xl text-lg md:text-xl font-medium leading-snug text-foreground/75">
              Announcements, research, hiring news and behind-the-scenes from across the Which Media brands — straight from the source.
            </p>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="linkedin-follow-cta"
              className="mt-8 inline-flex items-center gap-3 font-sans text-base font-bold bg-ink text-white rounded-full pl-6 pr-5 py-4 hover:bg-primary transition-colors"
            >
              <Linkedin size={20} /> Follow Which Media on LinkedIn <ArrowUpRight size={18} />
            </a>
          </div>
          <div className="lg:col-span-5">
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Which Media on LinkedIn"
              className="group block bg-ink rounded-3xl p-10 md:p-14 text-center transition-colors hover:bg-primary"
            >
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary group-hover:bg-white transition-colors mb-6">
                <Linkedin size={40} className="text-white group-hover:text-primary transition-colors" />
              </div>
              <p className="font-mono text-xs font-extrabold uppercase tracking-widest text-white/60 group-hover:text-white/80 transition-colors">
                linkedin.com/company
              </p>
              <p className="mt-2 headline text-2xl md:text-3xl uppercase text-white leading-tight">
                which-media-llc-fze
              </p>
            </a>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default LinkedInFollow;
